import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ly-row mt-2 ly-even-2" }

import { ref, computed, Ref, onMounted, inject } from 'vue'
import { useRoute } from 'vue-router'
import PasswordPoliciesList from '@/views/Common/components/PasswordPoliciesList.vue'
import { useConfigSync } from '@/config/useConfig'
import { Redirect } from '@/types/redirect'


export default /*@__PURE__*/_defineComponent({
  __name: 'NewResetPasswordForm',
  props: ['isSubmitting', 'hasExpiredCode'],
  emits: ['formSubmitted', 'errorCatched'],
  setup(__props, { emit: __emit }) {

const redirect = inject('redirect') as Redirect
const config = useConfigSync()
const props = __props
const route = useRoute()
const username: Ref<string> = ref('')
const code: Ref<string> = ref('')
const password: Ref<string> = ref('')
const repeatPassword: Ref<string> = ref('')
const formUsername: Ref<string> = ref('')
const emit = __emit
const disableForm = computed(() => {
  return props.hasExpiredCode ||
    !code.value ||
    !password.value ||
    !repeatPassword.value ||
    password.value !== repeatPassword.value ||
    !(username.value || formUsername.value) ||
    !isSymbolsPolicyMeet.value ||
    !isLengthPolicyMeet.value ||
    !isLowercasePolicyMeet.value ||
    !isRequireNumberPolicyMeet.value ||
    !isUppercasePolicyMeet.value
})

const displayError = (error : string | any) => {
  emit('errorCatched', error)
}

onMounted(() => {
  try {
    if (route?.query?.token) {
      const tokenData = JSON.parse(atob(route?.query?.token))

      if (!tokenData?.code) displayError({ message: 'The token provided is not valid or is already expired' })
      username.value = window.localStorage.getItem('email') || tokenData?.email

      code.value = `${tokenData?.code}`
    }
  } catch (error) {
    displayError({ message: 'The token provided is not valid or is already expired' })
    console.error('The token provided is not valid or is already expired')
  }
})

const formSubmitted = () => {
  emit('formSubmitted', {
    username: username.value || formUsername.value,
    code: code.value,
    password: password.value
  })
}

const isSymbolsPolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_symbols) return true
  return (/[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-]/.test(password.value))
})

const isLengthPolicyMeet = computed((): boolean => {
  return password.value.length >= config?.password_policy.minimum_length
})

const isLowercasePolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_lowercase) return true
  return (/[a-z]/.test(password.value))
})

const isRequireNumberPolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_numbers) return true
  return /\d/.test(password.value)
})

const isUppercasePolicyMeet = computed((): boolean => {
  if (!config.password_policy.require_uppercase) return true
  return (/[A-Z]/.test(password.value))
})

const goBack = () => {
  redirect('LoginView')
}


return (_ctx: any,_cache: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "reset-password-form",
    onSubmit: _withModifiers(formSubmitted, ["prevent"])
  }, [
    _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-center" }, "Reset Password", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-center" }, "Please type in your desired new password twice below.", -1)),
    (!username.value)
      ? (_openBlock(), _createBlock(_component_lp_input, {
          key: 0,
          modelValue: formUsername.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formUsername).value = $event)),
          type: "text",
          "label-top": "Email"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_lp_input, {
      modelValue: password.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
      type: "password",
      "label-top": "New password"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_lp_input, {
      modelValue: repeatPassword.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((repeatPassword).value = $event)),
      type: "password",
      "label-top": "Repeat password"
    }, null, 8, ["modelValue"]),
    _createVNode(PasswordPoliciesList, {
      isSymbolsPolicyMeet: isSymbolsPolicyMeet.value,
      isLengthPolicyMeet: isLengthPolicyMeet.value,
      isLowercasePolicyMeet: isLowercasePolicyMeet.value,
      isRequireNumberPolicyMeet: isRequireNumberPolicyMeet.value,
      isUppercasePolicyMeet: isUppercasePolicyMeet.value
    }, null, 8, ["isSymbolsPolicyMeet", "isLengthPolicyMeet", "isLowercasePolicyMeet", "isRequireNumberPolicyMeet", "isUppercasePolicyMeet"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: goBack,
        type: "button"
      }, " Go Back"),
      _createVNode(_component_lp_button, {
        disabled: disableForm.value || props.isSubmitting,
        loading: props.isSubmitting,
        type: "primary",
        class: "btn-loading-active"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Send", -1)
        ]))]),
        _: 1
      }, 8, ["disabled", "loading"])
    ])
  ], 32))
}
}

})